

// VenuemanagerPersonalPreferencesDialog.js
import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Grid,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material'
import { withFirebase } from '../Fb'
import { use } from 'react'

/*
 preferces: {
    showpaidamounts: true/false,
}
*/

function VenuemanagerPrsonalPreferencesDialog(props) {
  const { appdata, toggle, isOpen, firebase } = props
  console.log('user preferences dialog, appdata:', appdata)
  const [saving, setSaving] = useState(false)
  const [showDebug, setShowDebug] = useState(false)
  const [preferences, setPreferences] = useState({
    ...((appdata && appdata.userpreferences) || {})
  })

  console.log('isOpen:', isOpen, 'preferences:', preferences)

  useEffect(() => {
    if (appdata && appdata.userpreferences) {
      setPreferences({ ...appdata.userpreferences })
    }
  }, [appdata])

  const handleSave = () => {
    setSaving(true)
    firebase
      .savePersonVenueManagerConfigs(preferences)
      .then(() => {
        setSaving(false)
        toggle()
      })
      .catch((error) => {
        console.error('Error saving user preferences: ', error)
      })
  }

  const handleChange = (key, value) => {
    const newPreferences = { ...preferences, [key]: value }
    setPreferences(newPreferences)
  } 

  const toggleDebug = (e) => {
    // check if shift key is pressed then toggle
    if(e.shiftKey){
      setShowDebug(!showDebug)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={toggle}
      scroll='paper'
      aria-labelledby='personal-preferences-dialog-title'
      fullWidth={true}
      maxWidth='sm'
    >
      <DialogTitle onClick={toggleDebug}>Henkilökohtaiset asetukset</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel id="show-unpaid-amounts-label">Näytä maksettu osa tekstinä jos osittain maksettu</InputLabel>
          <Select
            labelId="show-unpaid-amounts-label"
            id="show-unpaid-amounts-select"
            value={preferences.showunpaidamounts || false}
            onChange={(e) => handleChange('showunpaidamounts', e.target.value)} 
          >
            <MenuItem value={true}>Kyllä</MenuItem>
            <MenuItem value={false}>Ei</MenuItem>
          </Select>
        </FormControl>
        {showDebug &&
          <pre>{JSON.stringify(preferences, null, 2)}</pre>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="secondary" disabled={saving}>
          Peruuta
        </Button>
        <Button onClick={handleSave} color="primary" disabled={saving}>
          Tallenna
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withFirebase(VenuemanagerPrsonalPreferencesDialog)